import { motion } from "framer-motion";

const IMG_B = "/photo-who-second.jpg";

const audiences = [
  {
    title: "The emerging executive",
    body: "A senior professional preparing for her first C-suite or board-level mandate, who wants to arrive already fluent in strategy and governance.",
  },
  {
    title: "The founder in transition",
    body: "An entrepreneur moving from operator to leader — building a company that can be governed, financed, and scaled beyond herself.",
  },
  {
    title: "The deliberate returner",
    body: "A woman re-entering senior professional life after a chapter away, determined to return at the level her experience deserves.",
  },
];

const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] } },
});

export const WhoItServes = () => (
  <section id="who" className="relative py-28 lg:py-40" data-testid="who-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <motion.div variants={fadeUp()} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="lg:sticky lg:top-32">
            <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">Who It Serves</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F5]" data-testid="who-heading">
              Women <em className="italic text-[#D4AF37]">32–59,</em> at the threshold of what comes next.
            </h2>
            <p className="mt-8 text-base sm:text-lg leading-relaxed text-white" data-testid="who-intro">
              SHE Global™ Institute is designed for women with real experience behind them — and a
              defined next chapter ahead. Not entry-level. Not hypothetical.
            </p>
            <div className="mt-10">
              <div className="overflow-hidden border border-white/10">
                <img src={IMG_B} alt="A Black woman executive leading a discussion with diverse colleagues around a boardroom table" className="w-full aspect-[4/3] object-cover" data-testid="who-portrait-b" />
              </div>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-7 flex flex-col justify-center gap-5 lg:pl-8">
          {audiences.map((a, i) => (
            <motion.div
              key={a.title}
              variants={fadeUp(0.1 + i * 0.12)}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              whileHover={{ x: 8 }}
              className="border border-white/10 bg-[#141414] p-10 hover:border-[#D4AF37]/50 transition-colors duration-500"
              data-testid={`who-audience-${i + 1}`}
            >
              <div className="flex items-baseline gap-6">
                <span className="font-serif-display italic text-[#D4AF37]/50 text-4xl shrink-0">0{i + 1}</span>
                <div>
                  <h3 className="font-serif-display text-2xl sm:text-3xl text-[#F5F5F5] mb-3">{a.title}</h3>
                  <p className="text-sm sm:text-base leading-relaxed text-white">{a.body}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
